import { useSearchParams } from 'react-router-dom';
import { normalizeColor } from '../helpers/colors';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || '1',
    title: getDefaultValue(
      searchParams.get('title'),
      'Enviem suas perguntas através do QR Code',
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    cols: searchParams.get('cols') || 3,
    titleFontSize: searchParams.get('titleFontSize') || '5.6',
    sizeQR: searchParams.get('sizeQR') || '20',
    authorFontSize: searchParams.get('authorFontSize') || '3.2',
    msgFontSize: searchParams.get('msgFontSize') || '2.5',
    clrTextAdvt:
      normalizeColor(searchParams.get('clrTextAdvt')) || 'rgba(255,255,255,1)',
    extraQrText: getDefaultValue(
      searchParams.get('extraQrText'),
      'use o qr code para enviar sua palavra pelo whatsapp',
    ),

    paddingQR: searchParams.get('paddingQR') || '0',
    socials: searchParams.get('socials'),
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    phoneNumber,
    clrBgAdvt: normalizeColor(searchParams.get('clrBgAdvt')) || 'rgba(0,0,0,0)',
  };
};
